import type { MediaRecord } from '../types'

export const verifiedReferenceMediaBatch3BySlug: Record<string, MediaRecord[]> = {
  'exserohilum-helminthosporium-leaf-blight': [
    {
      id: 'media-exserohilum-industrial-hemp-ncsu-license-review',
      url: 'https://eit-wagpress-prod.s3.amazonaws.com/media/images/2019-08-Exserohilum-Leaf-spot.max-700x1200.jpg',
      alt: 'Close-up of an industrial-hemp leaf with numerous small round lesions having dark-brown margins and gray-brown centers, presented by NC State Extension as Exserohilum leaf spot.',
      caption: 'NC State Extension Figure 1 Cannabis symptom reference. It shows the target-like round, dark-margined lesion pattern, but the landing page does not state an individual image creator, item-level reuse license, or plant-linked laboratory identifier.',
      creator: 'NC State Extension Plant Pathology; individual image creator not stated',
      license: 'Copyright/reuse and automated-training terms not stated on the NC State Extension landing page',
      sourceUrl: 'https://plantpathology.ces.ncsu.edu/news/exserohilum-leaf-spot-causing-problems-in-nc-hemp/',
      mediaType: 'image',
      requiredAttribution: 'NC State Extension Plant Pathology, Figure 1 in “Exserohilum Leaf Spot Causing Problems in NC Hemp” by Lindsey D. Thiessen, published August 16, 2019 and updated June 30, 2022. Obtain documented rights-holder permission before display, copying, modification, or automated training.',
      diagnosticLabel: 'exserohilum-helminthosporium-leaf-blight — institutional industrial-hemp symptom reference, license and plant-linked confirmation review required',
      hostSpecies: 'Cannabis sativa industrial hemp',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no media file is copied into the repository.',
        'Do not display, copy, modify, or use for automated training until reusable item-level rights are documented.',
        'The close-up does not provide whole-plant distribution, cultivar, crop stage, opposite leaf surface, lesion scale, time progression, or a plant-linked culture and molecular record.',
        'Round dark-bordered lesions overlap Bipolaris, Cercospora, Septoria, Alternaria, Curvularia, Fusarium, and abiotic injury; the institutional caption does not make a new image-only observation ground truth.',
        'Retain the landing-page context and route any proposed scientific label or crop to qualified human review.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: '052daf2b538cce9f86b41c2dd722ef753eefcbfeb7f5f327c927941221615f81',
      perceptualHash: 'dhash64:d396429c54a48aaa',
      width: 700,
      height: 933,
      view: 'close-up',
      stage: 'foliar symptoms; cultivar and production stage not stated',
      severity: 'moderate lesion burden; causal severity not established',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'spotted-cucumber-beetle': [
    {
      id: 'media-spotted-cucumber-beetle-rhododendrites-72669-ccbysa4',
      url: 'https://upload.wikimedia.org/wikipedia/commons/e/e9/Spotted_cucumber_beetle_%2872669%29.jpg',
      alt: 'Close-up dorsal-oblique photograph of a yellow-green spotted cucumber beetle with a black head, dark antennae, and black spots on its wing covers on non-Cannabis vegetation.',
      caption: 'Organism-only morphology reference photographed in Tennessee. The beetle is not on Cannabis, is not linked to plant injury, and has not been admitted as species-confirmed training ground truth.',
      creator: 'Rhododendrites',
      license: 'CC BY-SA 4.0',
      sourceUrl: 'https://commons.wikimedia.org/wiki/File:Spotted_cucumber_beetle_(72669).jpg',
      mediaType: 'image',
      requiredAttribution: 'Rhododendrites, “Spotted cucumber beetle (72669),” Wikimedia Commons, CC BY-SA 4.0. Link the license, indicate modifications, and distribute adaptations under the same or a compatible license.',
      diagnosticLabel: 'spotted-cucumber-beetle — visually identified adult morphology on non-Cannabis vegetation, organism-only scientific-review reference',
      hostSpecies: 'Non-Cannabis vegetation; visually identified Diabrotica undecimpunctata adult',
      hostContext: 'organism-only',
      useLimitations: [
        'Organism-only non-Cannabis reference; it does not document Cannabis host use, active feeding, injury, crop stage, canopy location, field distribution, progression, severity, or yield effect.',
        'The Commons identification and quality-image assessment do not substitute for a retained specimen or expert/key-based species and subspecies determination in a new observation.',
        'The dorsal-oblique view does not fully resolve ventral abdomen and leg characters and must not be used to separate eastern and western subspecies or similar chrysomelids by spot count alone.',
        'Keep this media outside Cannabis condition training and evaluation splits; a plant-linked feeding sequence and scientific label review remain required.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'scientific-review',
      trainingPermission: 'permitted',
      sha256: 'f8d038c6885ef1d26b7170ab16f1705a41bda7156051547db63918209d949f6b',
      perceptualHash: 'dhash64:3333c86868e0695c',
      width: 3302,
      height: 2330,
      view: 'close-up',
      stage: 'adult',
      severity: 'not applicable',
      confirmation: 'visual',
      trainingEligible: false,
    },
  ],
  'cabbage-looper-hemp': [
    {
      id: 'media-cabbage-looper-larva-bugwood-1327034-ccby3us',
      url: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/Trichoplusia_ni_larva.jpg',
      alt: 'Close-up of a pale-green Trichoplusia ni larva with thin pale longitudinal stripes and a body that broadens toward the rear on a non-Cannabis leaf.',
      caption: 'University of Georgia Bugwood organism-only morphology reference, image 1327034. The larva is on a non-Cannabis leaf and is not linked to hemp feeding injury.',
      creator: 'Alton N. Sparks, Jr., University of Georgia, Bugwood Network',
      license: 'CC BY 3.0 US',
      sourceUrl: 'https://commons.wikimedia.org/wiki/File:Trichoplusia_ni_larva.jpg',
      mediaType: 'image',
      requiredAttribution: 'Alton N. Sparks, Jr., University of Georgia, Bugwood Network, image 1327034. Licensed under CC BY 3.0 US; link the license and indicate modifications.',
      diagnosticLabel: 'cabbage-looper-hemp — Trichoplusia ni larval morphology on a non-Cannabis leaf, organism-only reference',
      hostSpecies: 'Non-Cannabis leaf; Trichoplusia ni larva',
      hostContext: 'organism-only',
      useLimitations: [
        'Organism-only non-Cannabis reference; it does not document Cannabis host use, a feeding event, leaf or flower injury, canopy location, crop stage, distribution, progression, or severity.',
        'The oblique dorsal view does not fully document the ventral proleg pattern or a looping gait and cannot by itself exclude soybean looper or another plusiine in a new observation.',
        'Keep organism-only media outside Cannabis condition training and evaluation splits even though the license permits reuse; require a plant-linked diagnostic sequence and human label review.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '8141b5267664d9d156422db069129bc5d71362a04833dd41c882cc0bc5bd78dd',
      perceptualHash: 'dhash64:399c5aacb6b18d2d',
      width: 3072,
      height: 2048,
      view: 'close-up',
      stage: 'larva',
      severity: 'not applicable',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'tarnished-plant-bug': [
    {
      id: 'media-tarnished-plant-bug-nymph-usda-ars-public-domain',
      url: 'https://upload.wikimedia.org/wikipedia/commons/2/2d/Lygus_lineolaris_2.jpg',
      alt: 'Dorsal-oblique close-up of a laboratory-reared tarnished plant bug nymph with a green rounded body, dark dorsal markings, long antennae, and developing wing pads.',
      caption: 'USDA Agricultural Research Service organism-only morphology reference, image K4186-11. The nymph is laboratory-reared and photographed on a non-Cannabis plant; it does not document hemp feeding injury.',
      creator: 'Scott Bauer, USDA Agricultural Research Service',
      license: 'Public domain — work of the U.S. federal government (USDA Agricultural Research Service)',
      sourceUrl: 'https://commons.wikimedia.org/wiki/File:Lygus_lineolaris_2.jpg',
      mediaType: 'image',
      requiredAttribution: 'Scott Bauer, USDA Agricultural Research Service, image K4186-11. Public domain U.S. federal government work. Wikimedia Commons landing page retained for provenance.',
      diagnosticLabel: 'tarnished-plant-bug — laboratory-reared Lygus lineolaris nymph morphology, organism-only reference',
      hostSpecies: 'Non-Cannabis plant; laboratory-reared Lygus lineolaris nymph',
      hostContext: 'organism-only',
      useLimitations: [
        'Organism-only laboratory reference; no Cannabis host, active feeding event, injury, crop stage, field distribution, progression, or severity is shown.',
        'The image supports nymph morphology only and must not be used to label foliar distortion, flower injury, seed injury, or a Cannabis infestation.',
        'Keep organism-only media outside Cannabis condition training and evaluation splits even though the U.S. federal-work license permits reuse.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: 'd85e220089d8d11c1e65d8c19eed037915fdbf470ce6efbb25dace6895971ff7',
      perceptualHash: 'dhash64:29034cb8326ed2b0',
      width: 640,
      height: 443,
      view: 'close-up',
      stage: 'laboratory-reared nymph',
      severity: 'not applicable',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'root-knot-nematodes': [
    {
      id: 'media-root-knot-m-incognita-cherry-figure2-ccby4',
      url: 'https://zenodo.org/api/records/11644653/files/figure.png/content',
      alt: 'Two-panel controlled reference showing an entire Cannabis sativa Cherry root system and a close-up of small white Meloidogyne incognita galls with a 5 mm scale.',
      caption: 'Figure 2 from Bernard, Chaffin, and Gwinn: controlled M. incognita galling on Cannabis sativa cultivar Cherry after an initial inoculum of 10,000 eggs. Panel A shows the full root system; panel B shows small white galls.',
      creator: 'Angel G. Chaffin, University of Tennessee (image credit); Ernest C. Bernard and Kimberly D. Gwinn (figure coauthors)',
      license: 'CC BY 4.0',
      sourceUrl: 'https://doi.org/10.5281/zenodo.11644653',
      mediaType: 'image',
      requiredAttribution: 'Bernard, Ernest C.; Chaffin, Angel G.; Gwinn, Kimberly D. (2021), Figure 2 in Review of nematode interactions with hemp (Cannabis sativa), Zenodo, https://doi.org/10.5281/zenodo.11644653. Licensed under CC BY 4.0.',
      diagnosticLabel: 'root-knot-nematodes — controlled M. incognita galling on Cannabis sativa Cherry, whole-root and close-up composite',
      hostSpecies: 'Cannabis sativa cultivar Cherry',
      hostContext: 'cannabis',
      useLimitations: [
        'Two-panel composite from one cultivar and a controlled initial inoculum of 10,000 eggs; it is not a panel-level training sample or a universal severity reference.',
        'The image supports small white Cannabis root-gall morphology but does not establish species from appearance alone; retain the article-linked M. incognita inoculation context.',
        'Do not crop away the scale, panel relationship, cultivar, inoculum, or source metadata; expert panel separation and label review are required before any automated training use.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '5fa94b0dcd841bbbff0307b76d816d656da6e913b6df98a28e762f7d5cb45751',
      perceptualHash: 'dhash64:a325725756064303',
      width: 1404,
      height: 826,
      view: 'root-crown',
      stage: 'controlled root-system endpoint',
      severity: 'not transferable; Pi = 10,000 eggs',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  thrips: [
    {
      id: 'media-thrips-hemp-bugwood-5569060',
      url: 'https://bugwoodcloud.org/images/1536x1024/5569060.jpg',
      alt: 'Severe onion-thrips feeding injury on a Cannabis sativa hemp leaf.',
      caption: 'Severe leaf injury to hemp produced by onion thrips (Thrips tabaci), Bugwood image 5569060.',
      creator: 'Whitney Cranshaw, Colorado State University, Bugwood.org',
      license: 'CC BY 3.0',
      sourceUrl: 'https://www.invasive.org/browse/detail.cfm?imgnum=5569060',
      mediaType: 'image',
      requiredAttribution: 'Whitney Cranshaw, Colorado State University, Bugwood.org, image 5569060. Licensed under CC BY 3.0.',
      diagnosticLabel: 'thrips — severe Thrips tabaci feeding injury on Cannabis sativa hemp',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-only feeding-damage image.',
        'Silvery or pale scars and speckling can overlap other pests or physical injury.',
        'Confirm thrips adults or larvae with magnification before making a species-level causal claim.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '04234384d5ab682600c748a65a62395adbf1cdfbe1f9489df43969025d53e54c',
      perceptualHash: 'dhash64:b3e78e80888094ca',
      width: 1536,
      height: 1152,
      view: 'close-up',
      stage: 'all',
      severity: 'high',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'dectes-stem-borer': [
    {
      id: 'media-dectes-adult-bugwood-5205012-ccby3',
      url: 'https://bugwoodcloud.org/images/1536x1024/5205012.jpg',
      alt: 'Lateral specimen close-up of an adult Dectes texanus showing dense gray pubescence and a long banded antenna.',
      caption: 'Organism-only adult morphology reference, Bugwood image 5205012. It does not show Cannabis, a feeding event, a larva, or stem injury.',
      creator: 'Natasha Wright, Braman Termite & Pest Elimination, Bugwood.org',
      license: 'CC BY 3.0',
      sourceUrl: 'https://www.invasive.org/browse/image/5205012',
      mediaType: 'image',
      requiredAttribution: 'Natasha Wright, Braman Termite & Pest Elimination, Bugwood.org, image 5205012. Licensed under CC BY 3.0.',
      diagnosticLabel: 'dectes-stem-borer — adult Dectes texanus morphology, organism-only specimen reference',
      hostSpecies: 'No host shown; Dectes texanus adult specimen',
      hostContext: 'organism-only',
      useLimitations: [
        'Organism-only lateral specimen; no Cannabis host, internal gallery, larva, feeding event, distribution, crop stage, or severity is shown.',
        'Do not use this image alone as causal ground truth for wilt, stem galleries, or breakage in Cannabis.',
        'Keep organism-only media outside Cannabis condition training and evaluation splits.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '2256abf6810648cd1564968cc0eb432981f278169c0b753f3b6a047aa844c9b6',
      perceptualHash: 'dhash64:f8c8f0ccf16d09dc',
      width: 391,
      height: 1536,
      view: 'close-up',
      stage: 'adult insect',
      severity: 'not applicable',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
    {
      id: 'media-dectes-soybean-illinois-video-license-review',
      url: 'https://www.youtube.com/watch?v=sJAYajsOW3Q',
      thumbnailUrl: 'https://i.ytimg.com/vi/sJAYajsOW3Q/hqdefault.jpg',
      alt: 'University of Illinois Extension video reviewing Dectes stem borer biology and management in soybean.',
      caption: 'Institutional soybean video reference by Nick Seiter. It is useful for inspection workflow context but is not Cannabis ground truth and has no verified reusable license.',
      creator: 'Nicholas J. Seiter, University of Illinois Extension',
      license: 'No explicit Creative Commons or automated-training license verified; YouTube-hosted institutional video',
      sourceUrl: 'https://news.utcrops.com/2020/03/video-about-dectes-stem-borer-in-soybean-dr-nick-seiter-univ-illinois/',
      mediaType: 'video',
      requiredAttribution: 'Nicholas J. Seiter, University of Illinois Extension; embedded by University of Tennessee Institute of Agriculture. Obtain rights-holder permission before copying, editing, display outside the source page, or automated training use.',
      diagnosticLabel: 'dectes-stem-borer — soybean biology and stem-inspection video, non-Cannabis transfer reference',
      hostSpecies: 'Glycine max',
      hostContext: 'non-cannabis',
      useLimitations: [
        'Reference-link metadata only; no video or thumbnail file is copied into the repository.',
        'Soybean biology, timing, symptoms, severity, thresholds, and management must not be treated as validated Cannabis labels or recommendations.',
        'Do not display, download, transform, frame-extract, or use for automated training until reusable rights are documented.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'unknown',
      view: 'close-up',
      stage: 'soybean field and dissected-stem educational sequence',
      severity: 'not applicable to Cannabis',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'japanese-beetle-hemp': [
    {
      id: 'media-japanese-beetle-adult-ucipm-ccby3',
      url: 'https://ipm.ucanr.edu/PMG/IMAGES/P/I-CO-PJAP-AD.005.jpg',
      alt: 'Dorsal close-up of an adult Japanese beetle showing metallic coloration and white abdominal hair patches.',
      caption: 'Organism-only adult morphology reference. The twelve white abdominal hair patches distinguish Japanese beetle from similar-looking beetles, but this image does not show hemp or feeding injury.',
      creator: 'Clemson University–USDA Cooperative Extension Slide Series, Bugwood.org',
      license: 'CC BY 3.0 US',
      sourceUrl: 'https://ipm.ucanr.edu/PMG/P/I-CO-PJAP-AD.005.html',
      mediaType: 'image',
      requiredAttribution: 'Clemson University–USDA Cooperative Extension Slide Series, Bugwood.org. Licensed under CC BY 3.0 US. Landing page: UC Statewide IPM Program.',
      diagnosticLabel: 'japanese-beetle-hemp — adult Popillia japonica morphology, organism-only reference',
      hostSpecies: 'No host shown; Popillia japonica adult specimen',
      hostContext: 'organism-only',
      useLimitations: [
        'Organism-only reference; no Cannabis host, feeding event, damage distribution, crop stage, or severity is shown.',
        'Do not use this image alone as causal ground truth for a damaged Cannabis plant.',
        'Keep organism-only media outside Cannabis condition training and evaluation splits.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: 'd0561325a787e5082ab8c56d303470f8940a7fa02d4299eaa3ac6501f83d2b77',
      perceptualHash: 'dhash64:f1f9f8cee4f0f076',
      width: 490,
      height: 490,
      view: 'close-up',
      stage: 'adult insect',
      severity: 'not applicable',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
    {
      id: 'media-japanese-beetle-on-hemp-unh-license-review',
      url: 'https://extension.unh.edu/sites/default/files/media/2025-05/5_japanesebeetle.jpg',
      thumbnailUrl: 'https://extension.unh.edu/sites/default/files/styles/max_width_480px/public/media/2025-05/5_japanesebeetle.jpg?itok=NQ88fHWn',
      alt: 'Adult Japanese beetle documented on a Cannabis sativa hemp plant by University of New Hampshire Extension.',
      caption: 'Metadata-only hemp-host reference credited to Whitney Cranshaw and Bugwood.org. The landing page does not state a reusable license for this asset.',
      creator: 'Whitney Cranshaw, Colorado State University, Bugwood.org',
      license: 'Copyright status/reuse license not stated on the UNH landing page',
      sourceUrl: 'https://extension.unh.edu/resource/hemp-pests-new-hampshire',
      mediaType: 'image',
      requiredAttribution: 'Whitney Cranshaw, Colorado State University, Bugwood.org; obtain documented permission or the original Bugwood license record before display, copying, modification, or training use.',
      diagnosticLabel: 'japanese-beetle-hemp — adult on Cannabis sativa, license-review reference',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no media file is copied into the repository.',
        'Do not display, copy, modify, or use for automated training until the original Bugwood record or rights holder establishes reusable terms.',
        'A single adult-on-hemp frame does not quantify active feeding, distribution, progression, severity, or crop loss.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'unknown',
      sha256: 'df443a4dc3cbbed2920439dd911d02066e7575b3aa9eb75c11726c4aa92f1c9b',
      perceptualHash: 'dhash64:f7fa7b73727278f9',
      width: 1031,
      height: 579,
      view: 'close-up',
      stage: 'outdoor hemp',
      severity: 'organism present; severity not established',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'pseudocercospora-olive-sooty-leaf-spot': [
    {
      id: 'media-pseudocercospora-cannabis-figure-1-ccby4',
      url: 'https://pub.mdpi-res.com/horticulturae/horticulturae-09-01261/article_deploy/html/images/horticulturae-09-01261-g001.png',
      alt: 'Multi-panel Pseudocercospora cannabina reference showing affected Cannabis canopy and leaves, lower-surface sooty conidial masses, culture, tissue section, conidiophores, and conidia.',
      caption: 'Natural Cannabis olive-leaf-spot symptoms and linked Pseudocercospora cannabina morphology from Harishchandra et al. 2023, Figure 1. Panels mix whole-canopy, upper and lower leaf surfaces, culture, section, and microscopy.',
      creator: 'Dulanjalee Lakmali Harishchandra, Sukanya Haituk, Patchareeya Withee, Nisachon Tamakaew, Nittaya Nokum, Chaorai Kanchanomai, Tonapha Pusadee, Chiharu Nakashima, and Ratchadawan Cheewangkoon; individual panel photographers not separately stated',
      license: 'CC BY 4.0',
      sourceUrl: 'https://www.mdpi.com/2311-7524/9/12/1261',
      mediaType: 'image',
      requiredAttribution: 'Harishchandra DL, Haituk S, Withee P, Tamakaew N, Nokum N, Kanchanomai C, Pusadee T, Nakashima C, Cheewangkoon R. 2023. First Molecular Phylogenetic Identification and Report of Pseudocercospora cannabina Causing Leaf Spot Disease on Cannabis sativa in Thailand. Horticulturae 9(12):1261, Figure 1. https://doi.org/10.3390/horticulturae9121261. CC BY 4.0.',
      diagnosticLabel: 'pseudocercospora-olive-sooty-leaf-spot — natural Cannabis symptoms plus Pseudocercospora cannabina morphology composite',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Mixed thirteen-panel composite spanning canopy, symptom close-ups, underside signs, culture, tissue section, and microscopy; reference-only as a whole figure.',
        'Do not treat individual panels or the full composite as independent single-class training examples until panel boundaries, labels, source grouping, and crop quality are reviewed.',
        'Upper-surface discoloration and lower-surface dark material overlap other pathogens and contaminants; unknown samples still require plant-linked morphology and molecular evidence.',
        'The field material came from one plantation in Chiang Rai, Thailand, and does not establish universal cultivar, geography, severity, or progression labels.',
        'The publisher has served visually identical PNG encodings with different byte hashes; dHash and dimensions remained stable. Treat SHA-256 as the source bytes observed on 2026-08-20, not a permanent publisher identifier.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '4e12bfc0910dcac974e79fb20f66cc138caa0d3f32fffa89ccd38b9624bac43c',
      perceptualHash: 'dhash64:8cc8a28ac0229218',
      width: 2606,
      height: 2393,
      view: 'diagram',
      stage: 'natural field symptoms and laboratory morphology',
      severity: 'mixed; includes severely affected field plants',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
    {
      id: 'media-pseudocercospora-cannabis-figure-2-pathogenicity-ccby4',
      url: 'https://pub.mdpi-res.com/horticulturae/horticulturae-09-01261/article_deploy/html/images/horticulturae-09-01261-g002.png',
      alt: 'Four-panel pathogenicity-test reference showing Pseudocercospora cannabina penetration through Cannabis lower-leaf stomata and reproduced conidiophores and conidia five days after inoculation.',
      caption: 'Controlled Cannabis pathogenicity sequence from Harishchandra et al. 2023, Figure 2: lower-surface stomatal penetration within 24 hours and symptom reproduction with conidiophores and conidia at 5 days post-inoculation.',
      creator: 'Dulanjalee Lakmali Harishchandra, Sukanya Haituk, Patchareeya Withee, Nisachon Tamakaew, Nittaya Nokum, Chaorai Kanchanomai, Tonapha Pusadee, Chiharu Nakashima, and Ratchadawan Cheewangkoon; individual panel photographers not separately stated',
      license: 'CC BY 4.0',
      sourceUrl: 'https://www.mdpi.com/2311-7524/9/12/1261',
      mediaType: 'image',
      requiredAttribution: 'Harishchandra DL, Haituk S, Withee P, Tamakaew N, Nokum N, Kanchanomai C, Pusadee T, Nakashima C, Cheewangkoon R. 2023. First Molecular Phylogenetic Identification and Report of Pseudocercospora cannabina Causing Leaf Spot Disease on Cannabis sativa in Thailand. Horticulturae 9(12):1261, Figure 2. https://doi.org/10.3390/horticulturae9121261. CC BY 4.0.',
      diagnosticLabel: 'pseudocercospora-olive-sooty-leaf-spot — controlled Cannabis pathogenicity microscopy and 5-day symptom reproduction composite',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Four-panel composite mixes microscopy at 24 hours with a macroscopic lower-surface panel at 5 days; reference-only as a whole figure.',
        'The 24-hour and 5-day observations came from a controlled wet-box inoculation and must not be used as universal field timing labels.',
        'Do not infer species from stomatal penetration or dark underside structures alone; retain the study-linked reisolation, morphology, and sequence context.',
        'Keep training-ineligible until panel crops, experimental labels, source grouping, and scale-bar preservation receive human review.',
        'The publisher has served visually identical PNG encodings with different byte hashes; dHash and dimensions remained stable. Treat SHA-256 as the source bytes observed on 2026-08-20, not a permanent publisher identifier.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'permitted',
      sha256: '753cb2fde39a613da04a06e204b38ae2bac6f3d7e12472524df2c9f0e19c9b1d',
      perceptualHash: 'dhash64:c9c9e9f9999999a9',
      width: 3714,
      height: 986,
      view: 'microscope',
      stage: '24-hour penetration and 5-day post-inoculation symptom reproduction',
      severity: 'early controlled infection',
      confirmation: 'lab-confirmed',
      trainingEligible: false,
    },
  ],
  'downy-mildew-pseudoperonospora': [
    {
      id: 'media-downy-mildew-ontario-early-lesions-license-review',
      url: 'https://onspecialtycrops.ca/wp-content/uploads/2021/07/072121-Fig-3.jpg',
      alt: 'Detached Cannabis leaf with small irregular reddish-brown lesions and uneven yellow-green halos, identified as early downy-mildew symptoms by Ontario crop specialists.',
      caption: 'Ontario field-hemp symptom reference credited to Amy Fang Shi, OGGA. The image shows early upper-surface lesions but no matched underside, canopy context, or plant-linked laboratory result.',
      creator: 'Amy Fang Shi, OGGA',
      license: 'Copyright/reuse and automated-training terms not stated on the Ontario Specialty Crops landing page',
      sourceUrl: 'https://onspecialtycrops.ca/2021/07/21/foliar-diseases-of-outdoor-hemp-cannabis-sativa-and-their-management-2021/',
      mediaType: 'image',
      requiredAttribution: 'Amy Fang Shi, OGGA; Figure 4 in “Foliar Diseases of Outdoor Hemp (Cannabis sativa) and Their Management 2021,” Ontario Specialty Crops. Obtain documented rights-holder permission before display, copying, modification, or automated training.',
      diagnosticLabel: 'downy-mildew-pseudoperonospora — early Cannabis upper-leaf symptom reference, rights and organism-link review required',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no media file is copied into the repository.',
        'Do not display, copy, modify, or use for automated training until reusable rights are documented.',
        'Detached upper-surface symptom image without matched underside, whole-plant context, collection metadata, or plant-linked laboratory confirmation; not ground truth.',
        'Irregular brown lesions and yellow halos overlap Septoria, Cercospora, Alternaria, bacterial leaf spot, and contact injury.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: '8cc1985227450b0b6297767aee8e49a7a0aaa91c87c41b48cbdab6913b6e1c59',
      perceptualHash: 'dhash64:48b1a33c714054a0',
      width: 1632,
      height: 1224,
      view: 'close-up',
      stage: 'early foliar symptoms; detached leaf',
      severity: 'low to moderate lesion coverage',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
    {
      id: 'media-downy-mildew-ontario-vein-limited-lesions-license-review',
      url: 'https://onspecialtycrops.ca/wp-content/uploads/2021/07/072121-Fig-4.jpg',
      alt: 'Detached Cannabis leaf with advanced reddish-brown lesions elongated and bounded by leaf veins, identified as downy-mildew progression by Ontario crop specialists.',
      caption: 'Ontario field-hemp progression reference credited to Amy Fang Shi, OGGA. It shows advanced vein-limited upper-surface lesions but not the corresponding lower-surface sporulation or plant-linked laboratory evidence.',
      creator: 'Amy Fang Shi, OGGA',
      license: 'Copyright/reuse and automated-training terms not stated on the Ontario Specialty Crops landing page',
      sourceUrl: 'https://onspecialtycrops.ca/2021/07/21/foliar-diseases-of-outdoor-hemp-cannabis-sativa-and-their-management-2021/',
      mediaType: 'image',
      requiredAttribution: 'Amy Fang Shi, OGGA; Figure 5 in “Foliar Diseases of Outdoor Hemp (Cannabis sativa) and Their Management 2021,” Ontario Specialty Crops. Obtain documented rights-holder permission before display, copying, modification, or automated training.',
      diagnosticLabel: 'downy-mildew-pseudoperonospora — advanced vein-limited Cannabis upper-leaf symptom reference, rights and organism-link review required',
      hostSpecies: 'Cannabis sativa',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no media file is copied into the repository.',
        'Do not display, copy, modify, or use for automated training until reusable rights are documented.',
        'Detached upper-surface symptom image without matched underside, whole-plant context, collection metadata, or plant-linked laboratory confirmation; not ground truth.',
        'Vein-bounded necrosis is compatible with downy mildew but overlaps other foliar pathogens and chemical or contact injury.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: '76ccc05651c8ad864f110b97341a43f3a06035ed6751f297d8f470b9a44bd8e7',
      perceptualHash: 'dhash64:9b9b4f6b2f9e5634',
      width: 1632,
      height: 1224,
      view: 'close-up',
      stage: 'advanced foliar symptoms; detached leaf',
      severity: 'moderate to high lesion coverage',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'serratia-marcescens-leaf-spot': [
    {
      id: 'media-hemp-bacterial-leaf-spot-ncsu-license-review',
      url: 'https://eit-wagpress-prod.s3.amazonaws.com/media/images/2019-08-Hemp-Serratia-Leaf-Spot.max-700x1200.jpg',
      alt: 'Detached industrial-hemp leaf with angular necrotic lesions, presented by NC State Extension as bacterial leaf spot and blight.',
      caption: 'NC State Extension Figure 2 generic bacterial leaf spot/blight differential. The page characterizes angular lesions but does not provide a species-level caption, plant-linked laboratory result, individual creator credit, or reusable license.',
      creator: 'NC State Extension Plant Pathology; individual image creator not stated',
      license: 'Copyright/reuse and automated-training terms not stated on the NC State Extension landing page',
      sourceUrl: 'https://plantpathology.ces.ncsu.edu/news/exserohilum-leaf-spot-causing-problems-in-nc-hemp/',
      mediaType: 'image',
      requiredAttribution: 'NC State Extension Plant Pathology, Figure 2 in “Exserohilum Leaf Spot Causing Problems in NC Hemp” by Lindsey D. Thiessen, published August 16, 2019. Obtain documented rights-holder permission and species-level provenance before display, copying, modification, or automated training.',
      diagnosticLabel: 'serratia-marcescens-leaf-spot — generic industrial-hemp bacterial leaf spot/blight differential, not Serratia ground truth',
      hostSpecies: 'Cannabis sativa industrial hemp',
      hostContext: 'cannabis',
      useLimitations: [
        'Reference-link metadata only; no media file is copied into the repository.',
        'Do not display, copy, modify, or use for automated training until reusable rights are documented.',
        'The landing page labels the figure only as bacterial leaf spot and blight with angular lesions; do not convert the asset filename into a Serratia species label.',
        'Detached-leaf close-up lacks whole-plant distribution, matched opposite surface, progression, scale, collection metadata, and plant-linked culture or molecular confirmation.',
        'Angular lesions overlap Xanthomonas and other bacterial diseases, downy mildew, fungal leaf spots, and contact injury.',
      ],
      displayPermission: 'unknown',
      reviewStatus: 'license-review',
      trainingPermission: 'not-permitted',
      sha256: '72708024736bedbcd0dfd34d81c262b463bd6dd878d253b38b61fd8b3438afc8',
      perceptualHash: 'dhash64:c0849c4c408c4000',
      width: 624,
      height: 864,
      view: 'close-up',
      stage: 'detached industrial-hemp leaf; production stage not stated',
      severity: 'moderate lesion coverage; causal severity not established',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
  'herbicide-clomazone-bleaching-injury': [
    {
      id: 'media-clomazone-grape-vapor-drift-ncsu-cc-by-nc-sa-4',
      url: 'https://content.ces.ncsu.edu/media/images/3.png',
      alt: 'Close-up of a non-Cannabis grape leaf with broad nearly white pigment-loss zones along the margins and between still-green major veins after clomazone vapor drift.',
      caption: 'NC State Extension clomazone vapor-drift reference on grape. It illustrates near-white pigment loss with retained green vein regions, but it is not a Cannabis sample and does not establish a universal clomazone pattern.',
      creator: 'J. Neal, NC State Extension',
      license: 'CC BY-NC-SA 4.0',
      sourceUrl: 'https://content.ces.ncsu.edu/carotenoid-pigments',
      mediaType: 'image',
      requiredAttribution: 'J. Neal, “Clomazone vapor drift on grape,” NC State Extension, Carotenoid Pigments. Licensed under CC BY-NC-SA 4.0; attribution, noncommercial use, and ShareAlike terms apply.',
      diagnosticLabel: 'herbicide-clomazone-bleaching-injury — clomazone vapor-drift pigment loss on grape, non-Cannabis transfer reference',
      hostSpecies: 'Vitis sp. (grape), not Cannabis',
      hostContext: 'non-cannabis',
      useLimitations: [
        'Non-Cannabis transfer reference; do not use it to label Cannabis condition, severity, dose, route, progression, or recovery.',
        'One close-up lacks whole-field distribution, application history, temporal sequence, unaffected comparison, and laboratory residue linkage.',
        'The CC BY-NC-SA license restricts reuse to noncommercial purposes and requires adaptations to use the same license; automated training is prohibited by dataset policy.',
        'Retained green vein regions and white margins are not clomazone-specific and can overlap micronutrient, pathogen, light, or imaging effects.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'not-permitted',
      sha256: '705eedf9c47ba7233731d27cbbc3ae2f52a8d65fb2922512f21c43487f61069f',
      perceptualHash: 'dhash64:97793950b133c664',
      width: 286,
      height: 319,
      view: 'close-up',
      stage: 'non-Cannabis clomazone vapor-drift injury; timing not stated',
      severity: 'substantial pigment loss on one grape leaf; not transferable to Cannabis',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
    {
      id: 'media-clomazone-pokeweed-field-edge-ncsu-cc-by-nc-sa-4',
      url: 'https://content.ces.ncsu.edu/media/images/7.png',
      alt: 'Whole-shoot view of non-Cannabis pokeweed beside a fence line, with multiple leaves showing broad pale-to-white interveinal pigment loss after clomazone vapor drift.',
      caption: 'NC State Extension field-edge context reference. Compatible bleaching on a susceptible weed beside the treated-field boundary can strengthen a vapor-drift hypothesis, but neither the weed nor the spatial clue proves clomazone exposure in Cannabis.',
      creator: 'J. Neal, NC State Extension',
      license: 'CC BY-NC-SA 4.0',
      sourceUrl: 'https://content.ces.ncsu.edu/carotenoid-pigments',
      mediaType: 'image',
      requiredAttribution: 'J. Neal, clomazone vapor-drift injury on pokeweed at a field edge, NC State Extension, Carotenoid Pigments. Licensed under CC BY-NC-SA 4.0; attribution, noncommercial use, and ShareAlike terms apply.',
      diagnosticLabel: 'herbicide-clomazone-bleaching-injury — clomazone vapor-drift field-edge context on pokeweed, non-Cannabis transfer reference',
      hostSpecies: 'Phytolacca americana (pokeweed), not Cannabis',
      hostContext: 'non-cannabis',
      useLimitations: [
        'Non-Cannabis spatial-context reference; do not infer Cannabis injury, active ingredient, dose, direction, source, or legal responsibility from this image.',
        'The frame shows one susceptible weed at a fence line without a mapped affected/unaffected transect, weather record, application record, or residue result.',
        'The CC BY-NC-SA license restricts reuse to noncommercial purposes and requires adaptations to use the same license; automated training is prohibited by dataset policy.',
        'A shared edge pattern is supporting exposure evidence only and must be paired with Cannabis observations and an independently plausible exposure pathway.',
      ],
      displayPermission: 'permitted',
      reviewStatus: 'approved-reference',
      trainingPermission: 'not-permitted',
      sha256: 'e5114535d16315c3a2ec95fcda21cfdaa752af80756451953e20d991d575207c',
      perceptualHash: 'dhash64:9c2c72d3199e8626',
      width: 371,
      height: 532,
      view: 'whole-plant',
      stage: 'non-Cannabis field-edge vapor-drift injury; timing not stated',
      severity: 'multiple bleached pokeweed leaves; not transferable to Cannabis',
      confirmation: 'expert-reviewed',
      trainingEligible: false,
    },
  ],
}
